import React from "react";

export const CookieListItem = ({ cookieKey, label }: { cookieKey: string; label?: string }) => {
	const cookieValue = eXpress.platform.cookies.getCookie(cookieKey) === "true";

	const onChange = (key: string, value: string) => {
		eXpress.platform.cookies.setCookie(key, value, {
			path: "/",
		});
	};

	return (
		<div className="cookie-list__item">
			<div>{label || cookieKey}</div>
			<input
				type="checkbox"
				defaultChecked={cookieValue}
				onChange={(e) => onChange(cookieKey, e.currentTarget.checked.toString())}
			/>
		</div>
	);
};
CookieListItem.displayName = "CookieListItem";
